// Tiny event bus so audio code can announce sounds / beats and honour the volume setting.
const listeners = { notice: new Set(), beat: new Set(), volume: new Set() };
let volume = (() => { try { return Number(JSON.parse(localStorage.getItem("jt_a11y") || "{}").volume ?? 1); } catch (e) { return 1; } })();

export const on = (type, fn) => { listeners[type].add(fn); return () => listeners[type].delete(fn); };
export const soundNotice = (text) => listeners.notice.forEach((fn) => fn(text));
export const beatPulse = (down = false) => listeners.beat.forEach((fn) => fn(down));
export const getVolume = () => volume;
export const setVolume = (v) => { volume = v; listeners.volume.forEach((fn) => fn(v)); };
export const prettyPitch = (p) => String(p).replace("#", "♯").replace(/b(?=\d)/, "♭");
